"use client";

/**
 * CMS block `login-button`: đăng nhập trong header; chỉnh sửa site trên dash.
 * Giữ export để JSON cũ không lỗi; không render thêm trong header.
 */
const LoginButton = () => null;

export default LoginButton;
